/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { LineSegments } from 'three';
let ShapeLineSegment = class ShapeLineSegment extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometry = Solids.createLineSegment(shape.x1, shape.y1, 0, shape.x2, shape.y2, 0);
        if (decoration != null && decoration.LineWidth > 0) {
            this.add(new LineSegments(geometry, CrownShape.getLineMaterial(decoration)));
        }
    }
    format() {
        return undefined;
    }
};
ShapeLineSegment = tslib_1.__decorate([
    Shape('Shape.LineSegment'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], ShapeLineSegment);
export { ShapeLineSegment };
//# sourceMappingURL=ShapeLineSegment.js.map